/* Nav refresh — desktop hover collection previews + mobile menu sheet.
   Loaded deferred from sections/header.liquid. */
(function () {
  var SECTION_ID = 'nav-preview-cards';
  var cache = {};
  var inflight = {};

  /* ---------- Desktop: hover a collection sub-link to preview its products ---------- */
  function initDesktopPreviews(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    root.querySelectorAll('.menu-subs').forEach(function (panel) {
      if (panel.dataset.navPreviewInit) return;
      var cardsEl = panel.querySelector('[data-nav-cards]');
      if (!cardsEl) return;
      panel.dataset.navPreviewInit = 'true';

      var defaultHTML = cardsEl.innerHTML;
      var links = panel.querySelectorAll('.drp_left a[data-nav-preview]');
      var timer = null;
      var swapTimer = null;
      var current = '__default__'; // what the cards currently show
      var wanted = '__default__'; // what the pointer most recently asked for

      function setCur(url) {
        links.forEach(function (a) {
          a.classList.toggle('nav-link-cur', a.getAttribute('data-nav-preview') === url);
        });
      }

      function swap(html, key) {
        clearTimeout(swapTimer);
        cardsEl.classList.add('nav-cards--swapping');
        swapTimer = setTimeout(function () {
          cardsEl.innerHTML = html;
          cardsEl.classList.remove('nav-cards--swapping');
        }, 140);
        current = key;
      }

      links.forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var url = a.getAttribute('data-nav-preview');
            wanted = url;
            if (url === current) return;

            if (Object.prototype.hasOwnProperty.call(cache, url)) {
              // Cached '' means the section rendered no cards — keep current view.
              if (cache[url]) {
                swap(cache[url], url);
                setCur(url);
              }
              return;
            }
            if (inflight[url]) return;
            inflight[url] = true;

            var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SECTION_ID;
            fetch(fetchUrl)
              .then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.text();
              })
              .then(function (text) {
                delete inflight[url];
                var doc = new DOMParser().parseFromString(text, 'text/html');
                var inner = doc.querySelector('[data-nav-preview-cards]');
                var html = inner && inner.children.length ? inner.innerHTML : '';
                cache[url] = html;
                // Only touch the UI if this URL is still the hovered target.
                if (html && wanted === url) {
                  swap(html, url);
                  setCur(url);
                }
              })
              .catch(function () {
                // Not cached — the next hover retries.
                delete inflight[url];
              });
          }, 130);
        });
        a.addEventListener('mouseleave', function () {
          clearTimeout(timer);
        });
      });

      // Leaving the whole menu item restores the default cards
      var li = panel.closest('li');
      if (li) {
        li.addEventListener('mouseleave', function () {
          clearTimeout(timer);
          clearTimeout(swapTimer);
          cardsEl.classList.remove('nav-cards--swapping');
          wanted = '__default__';
          if (current !== '__default__') {
            cardsEl.innerHTML = defaultHTML;
            current = '__default__';
            setCur(null);
          }
        });
      }
    });
  }

  /* ---------- Mobile: sheet tabs + backdrop / close button ---------- */
  function initSheet(root) {
    root.querySelectorAll('header-drawer').forEach(function (drawer) {
      if (drawer.dataset.navSheetInit) return;
      var menu = drawer.querySelector('.menu-drawer.nav-sheet');
      if (!menu) return;
      drawer.dataset.navSheetInit = 'true';
      var summary = drawer.querySelector('details > summary');

      // The sheet opens just below the header's current top edge, so it
      // clears the announcement bar at any height (it wraps on small
      // screens) and hugs the viewport top once the bar scrolls away.
      var headerWrap = document.querySelector('.header-wrapper');
      function updateSheetTop() {
        if (!headerWrap) return;
        var top = Math.max(Math.round(headerWrap.getBoundingClientRect().top), 8);
        menu.style.setProperty('--nav-sheet-top', top + 'px');
      }
      updateSheetTop();
      if (summary) summary.addEventListener('click', updateSheetTop);
      window.addEventListener('resize', updateSheetTop);

      var tabs = Array.prototype.slice.call(menu.querySelectorAll('.nav-sheet__tab'));
      var panes = menu.querySelectorAll('.nav-sheet__pane');

      function activate(id, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-pane') === id;
          t.classList.toggle('nav-sheet__tab--on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) t.focus();
        });
        panes.forEach(function (p) {
          p.hidden = p.getAttribute('data-pane') !== id;
        });
      }

      tabs.forEach(function (t, i) {
        t.setAttribute('tabindex', t.classList.contains('nav-sheet__tab--on') ? '0' : '-1');
        t.addEventListener('click', function () {
          activate(t.getAttribute('data-pane'));
        });
        t.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = tabs[(i + dir + tabs.length) % tabs.length];
          activate(next.getAttribute('data-pane'), true);
        });
      });

      function close() {
        var details = summary && summary.closest('details');
        if (details && details.hasAttribute('open')) summary.click();
      }

      // Tap on the dimmed backdrop (the drawer element itself) closes
      menu.addEventListener('click', function (e) {
        if (e.target === menu) close();
      });
      var x = menu.querySelector('.nav-sheet__x');
      if (x) x.addEventListener('click', close);
    });
  }

  function initAll(root) {
    initDesktopPreviews(root);
    initSheet(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor re-renders sections in place — re-bind within the reloaded section.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
